import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicGridComponent } from './dynamic-grid/dynamic-grid.component';
import { TimeseriesChartComponent } from './timeseries-chart/timeseries-chart.component';
import { FormsModule } from '@angular/forms';
import { MatSliderModule } from '@angular/material';
import {ChartModule } from 'angular-highcharts';
import { ToastsManager } from 'ng2-toastr';
import { ToastOptions } from 'ng2-toastr/src/toast-options';
import { ToastContainer } from 'ng2-toastr';
import {ToastModule} from 'ng2-toastr/ng2-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TopNavComponent } from './top-nav/top-nav.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MatSliderModule,
    ChartModule,
     ToastModule,
    BrowserAnimationsModule
  ],
  entryComponents: [ToastContainer],
  
  declarations: [DynamicGridComponent,
      TimeseriesChartComponent,
      TopNavComponent
    ],
    
    providers:[ToastsManager,
      ToastOptions],
    
      exports: [ 
      TimeseriesChartComponent,
      DynamicGridComponent,
      TopNavComponent
    ]

})
export class ComponentsModule { }
